module.exports = __webpack_public_path__ + "img/sponsorI33.a2cff15d.png";